import type { ITkDialogProps } from "../../../type/componentsType/TkDialog";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import "./_style.scss";
import TkButton from "../TkButton";

/**
 * ダイアログ部品
 * TkDialogコンポーネントは、他のウインドーより手前に表示されるものです。
 * @param {boolean} open - ダイアログが開いているかどうか。
 * @param {Function} onClose - ダイアログの閉じるイベントを処理するコールバック関数。
 * @param {ReactNode} children - ダイアログの内容。
 * @param {string} className - ダイアログの追加のCSSクラス名。
 * @param {string} title - ダイアログのタイトル。
 * @param {string} contextText - ダイアログのコンテキストテキスト。
 * @param {ReactNode} actions - ダイアログに表示されるボタン。
 * @param {boolean} buttonOnTop - ダイアログのアクションボタンを上部に表示するかどうか。
 * @returns TkDialog ダイアログ部品
 */
export const TkDialog: React.FC<ITkDialogProps> = ({
  open = false,
  onClose,
  onCancel,
  onSave,
  children,
  className,
  title = "",
  contextText = "",
  buttonOnTop = false,
  saveData,
  clearSaveData,
  cancelText = "キャンセル",
  okText = "確定",
  ...rest
}) => {
  const handleSave = () => {
    onSave && onSave(saveData);
    clearSaveData && clearSaveData();
  };

  const handleClose = () => {
    onClose && onClose();
    clearSaveData && clearSaveData();
  };

  const handleCancel = () => {
    onCancel && onCancel();
    clearSaveData && clearSaveData();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={`tkDialog ${className}`}
      data-testid="tkDialogForTest"
      {...rest}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent className="context">
        {contextText && <DialogContentText>{contextText}</DialogContentText>}
        {children}
      </DialogContent>
      {(cancelText || okText) && (
        <DialogActions
          className={`${buttonOnTop ? "buttonOnTop" : ""}`}
          data-testid="dialog-actions"
        >
          <>
            {cancelText && (
              <TkButton
                data-testid="tkDialogCancelButtonForTest"
                onClick={handleCancel}
              >
                {cancelText}
              </TkButton>
            )}
            {okText && (
              <TkButton
                data-testid="tkDialogOkButtonForTest"
                onClick={handleSave}
              >
                {okText}
              </TkButton>
            )}
          </>
        </DialogActions>
      )}
    </Dialog>
  );
};
export default TkDialog;
